export default __webpack_public_path__ + "static/media/GilroyChatIcon.2bcb1b47.svg";